import ContextMenu from '@/components/ContextMenu/ContextMenu.jsx'
import useMenuItemColumnVisibility from './useMenuItemColumnVisibility.jsx'
import useMenuItemExport from './useMenuItemExport.jsx'
import useMenuItemResetTable from './useMenuItemResetTable.jsx'
import useMenuItemRowStripe from './useMenuItemRowStripe.jsx'

export default function ContextMenuConfig({table, ...props}) {
    const items = [
        useMenuItemRowStripe(table),
        useMenuItemColumnVisibility(table),
        useMenuItemExport(table),
        {divider: true},
        useMenuItemResetTable(table),
    ]

    return (
        <ContextMenu
            items={items}
            {...props}
        />
    )
}
